import React from 'react'
import { NavLink } from 'react-router-dom'

function Navbar() {
  return (
    <div className='navbar'>
      <NavLink to="/restaurant/alltable" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
        All Tables
      </NavLink>
      <NavLink to="/restaurant/mytable" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
        My Tables
      </NavLink>

    </div>
  )
}

export default Navbar
